import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui-kit/card';
import { Badge } from '@/components/ui-kit/badge';
import { PerformanceDashboard, QuantitativeMetric } from '../../types/dashboard.types';

export interface QuantitativeScoringProps {
  dashboard: PerformanceDashboard;
}

const achievementVariant = (percent: number): 'default' | 'secondary' | 'destructive' => {
  if (percent >= 100) return 'default';
  if (percent >= 75) return 'secondary';
  return 'destructive';
};

const formatNumber = (value: number) => value.toLocaleString(undefined, { maximumFractionDigits: 2 });

export const QuantitativeScoring = ({ dashboard }: QuantitativeScoringProps) => {
  const { t } = useTranslation();

  let metrics: QuantitativeMetric[] = [];
  try {
    metrics = JSON.parse(dashboard.QuantitativeMetricsJson) as QuantitativeMetric[];
  } catch {
    metrics = [];
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('QUANTITATIVE_SCORING')}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {metrics.map((metric) => (
          <div key={metric.Metric} className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1 border-b py-2 text-sm last:border-0">
            <span>{metric.Metric}</span>
            <div className="flex items-center gap-3">
              <span className="text-muted-foreground">
                {formatNumber(metric.Actual)} / {formatNumber(metric.Target)}
              </span>
              <Badge variant={achievementVariant(metric.AchievementPercent)}>
                {metric.AchievementPercent.toFixed(0)}%
              </Badge>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
